import { createApi } from '../callApi';
const billingApi = createApi('BILLING');

export const fetchSubscription = () => {
    return billingApi({ method: 'GET', target: '/subscriptions' });
};
export const fetchPrices = () => {
    return billingApi({ method: 'GET', target: '/prices' });
};
export const fetchSponsorshipCode = () => {
    return billingApi({ method: 'GET', target: '/sponsorship/code' });
};
export const getStripeCustomerPortalSession = () => {
    return billingApi({
        method: 'GET',
        target: '/customer_portal',
        query: {
            redirect_url: window.location.href,
        },
    });
};
export const checkReferer = (code) => {
    return billingApi({ method: 'GET', target: '/referer_codes', query: { code } });
};
export const updateSponsorshipCode = (body) => {
    return billingApi({ method: 'PUT', target: '/referer_codes', body });
};
export const resumeSubscription = () => {
    return billingApi({ method: 'POST', target: '/subscriptions/resume' });
};
export const resignSubscription = (body) => {
    return billingApi({ method: 'DELETE', target: '/subscriptions', body });
};
export const switchSubscriptionPlan = (body) => {
    return billingApi({ method: 'POST', target: '/subscriptions/swap', body });
};
export const reactivateSubscription = () => {
    return billingApi({ method: 'POST', target: '/subscriptions/reactivate' });
};
export const addShowPricesQuota = (body) => {
    return billingApi({ method: 'POST', target: '/subscriptions/preview', body });
};
export const updateShowQuota = (body) => {
    return billingApi({ method: 'PUT', target: '/subscriptions', body });
};
export const createStripeCheckoutSession = ({ currency, isYearly, price }) => {
    return billingApi({
        method: 'POST',
        target: '/checkout',
        body: {
            currency,
            is_yearly: isYearly,
            price,
            success_url: `${window.location.origin}/checkout-success?offer=${price}`,
            cancel_url: `${window.location.href}${
                window.location.href.includes('?') ? '&fromCheckout=true' : '?fromCheckout=true'
            }`,
        },
    });
};
